<template>
  <div>
    <Classes v-if="!loggedIn" />
    <template v-else>
      <van-notice-bar
        style="margin:16px;padding:16px"
        color="#333"
        background="#f3f3f3"
        left-icon="info-o"
        wrapable
        :scrollable="false"
      >
        Welcome, {{ welcomeName }}
      </van-notice-bar>

      <div
        style="padding-left:16px;padding-right:16px;padding-top:16px;border-top:1px solid #e3e3e3"
      >
        <h3>{{ $t("continue") }}</h3>
      </div>
      <Tiles
        v-if="
          lastSeenBoxes && lastSeenBoxes.results && lastSeenBoxes.results.length
        "
        :items="lastSeenBoxes.results"
        tileType="box"
      />
      <div
        v-else
        style="padding-left:16px;padding-right:16px;padding-top:16px;border-top:1px solid #e3e3e3"
      >
        <p>{{ $t("dashboard continue is empty") }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Classes from "@/components/Classes";
import axios from "@/helpers/axios";
import Tiles from "@/components/Tiles";
export default {
  name: "Home",
  components: { Classes, Tiles },
  data() {
    return {
      lastSeenBoxes: []
    };
  },
  methods: {
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    async getData() {
      try {
        const { data } = await axios.get(`/stats/last-seen-boxes/`);
        this.lastSeenBoxes = data;
      } catch (err) {
        //
      }
    }
  },
  computed: {
    ...mapState("account", ["user", "loggedIn"]),
    welcomeName() {
      const { user } = this;
      if (!user) {
        return "";
      }
      return user.name ? user.name : user.email;
    }
  },
  created() {
    this.SET_PAGE_TITLE(this.loggedIn ? this.$t("my dashboard") : "vokabox");
    this.getData();
  }
};
</script>
